// 不能做的原因（SPEC #device-permissions-ui、UX-04 / UX-09）：依 denied[].reason 查多語系表 deny.*，不顯示工程用語。
import type { DeviceAccess } from './devices';
import type { MeDenied } from './myDevices';

type T = (k: string, o?: Record<string, unknown>) => string;

function fmtDate(v: unknown, lang?: string): string {
  if (typeof v !== 'string' || !v) return '';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString(lang, { month: 'numeric', day: 'numeric' });
}

/** 一個原因的文案（例：「分享已於 10/12 到期」「只在警報後 30 分鐘內可看」「需要開啟兩步驟驗證」）。 */
export function denialText(t: T, d: Pick<MeDenied, 'reason' | 'detail'>, lang?: string): string {
  const detail = d.detail ?? {};
  const n = typeof detail.window_minutes === 'number' ? detail.window_minutes : 30;
  const date = fmtDate(detail.expires_at ?? detail.until ?? detail.since, lang);
  if (d.reason === 'share_expired' && !date) return t('deny.share_expired_nodate');
  return t(`deny.${d.reason}`, { n, date, defaultValue: t('deny.not_granted') });
}

/** 這台做不了 action 的原因（有 denied 就用它；沒有 = 沒有授予）。可以做 → null。 */
export function whyNot(t: T, access: DeviceAccess | undefined, action: string, lang?: string): string | null {
  if (access?.actions.includes(action)) return null;
  const d = access?.denied.find((x) => x.action === action);
  return d ? denialText(t, d, lang) : t('deny.not_granted');
}

/** 同一個原因只列一次（多個動作同一個原因時，例如整個組織要求 MFA）。 */
export function uniqueDenials(list: MeDenied[]): MeDenied[] {
  const seen = new Set<string>();
  const out: MeDenied[] = [];
  for (const d of list) {
    const k = d.reason + '|' + JSON.stringify(d.detail ?? {});
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(d);
  }
  return out;
}
